<template>
  <!-- Authors Table Card -->
  <a-card :bordered="false" class="header-solid h-full" :bodyStyle="{ padding: 10 }">
    <template #title>
      <a-row type="flex" align="middle">
        <a-col :span="24" :md="12">
          <h5 class="font-semibold m-0">Alumni Data</h5>
        </a-col>
        <a-col :span="24" :md="12" style="display: flex; align-items: center; justify-content: flex-end">
        </a-col>
      </a-row>

      <!-- Button Group -->
      <a-row style="margin-top: 20px">
        <a-col :span="10">
          <a-input-search style="margin-left: 0px" placeholder="input search text" enter-button
            v-model="formSearch.searchText" @search="onSearchDataProfile" />
        </a-col>
        <a-col :span="14" align="right">
          <a-button type="primary" class="mr-5" @click="onShowModal('typeImport')">
            <a-icon type="file-excel" theme="outlined" />
            Import
          </a-button>
          <a-button type="primary" :disabled="loadBtnExport" class="mr-5 bg-success"
            @click="onShowModal('exportAlumniData')">
            <a-icon v-if="!loadBtnExport" type="file-excel" theme="outlined" /><a-spin v-else /> Exports
          </a-button>
          <a-button type="primary" @click="onShowModal('createProfile')"> + Create </a-button>
        </a-col>
      </a-row>

      <!-- Filter -->
      <div class="mt-20 mb-5" style="background: #ececec; padding: 10px">
        <a-card class="ant-card-filter" style="box-shadow: none">
          <a-row>
            <a-col :xs="24" :sm="12" :md="8" :lg="6">
              <p class="lable-title">Member status :</p>
              <a-button-group>
                <a-button :type="formSearch.member === 'member' ? 'primary' : 'default'"
                  @click="handleMemberStatusChange('member')">
                  Member
                </a-button>
                <a-button :type="formSearch.member === 'non-member' ? 'primary' : 'default'"
                  @click="handleMemberStatusChange('non-member')">
                  Non-Member
                </a-button>
              </a-button-group>
            </a-col>
            <a-col :xs="24" :sm="12" :md="8" :lg="6">
              <p class="lable-title">Graduation Year :</p>
              <a-select show-search placeholder="Start" style="width: 40%" option-filter-prop="children"
                v-model="formSearch.yearStart">
                <a-select-option v-for="(item, index) in optionYear" :key="index" :value="item">
                  {{ item }}
                </a-select-option>
              </a-select>
              -
              <a-select show-search placeholder="End" style="width: 40%" option-filter-prop="children"
                v-model="formSearch.yearEnd">
                <a-select-option v-for="(item, index) in optionYear" :key="index" :value="item">
                  {{ item }}
                </a-select-option>
              </a-select>
            </a-col>
            <a-col :xs="24" :sm="12" :md="8" :lg="6">
              <p class="lable-title">Job Sectors :</p>
              <a-select class="ant-select" show-search placeholder="select..." option-filter-prop="children"
                v-model="formSearch.jobStatus">
                <a-select-option v-for="(item, index) in optionJobselect" :key="index" :value="item.value">
                  {{ item.text }}
                </a-select-option>
              </a-select>
            </a-col>
            <a-col :xs="24" :sm="12" :md="8" :lg="6">
              <p class="lable-title">Nationality :</p>
              <a-select class="ant-select" show-search placeholder="select..." option-filter-prop="children"
                v-model="formSearch.nationality">
                <a-select-option v-for="(item, index) in optionNationality" :key="index" :value="item.value">
                  {{ item.text }}
                </a-select-option>
              </a-select>
            </a-col>
          </a-row>

          <!-- zone C -->
          <a-row style="margin-top: 20px">
            <a-col :xs="24" :sm="12" :md="8" :lg="6">
              <p class="lable-title">Major :</p>
              <a-select class="ant-select" show-search placeholder="select..." option-filter-prop="children"
                v-model="formSearch.major">
                <a-select-option v-for="(item, index) in optionMajor" :key="index" :value="item.value">
                  {{ item.text }}
                </a-select-option>
              </a-select>
            </a-col>
            <a-col :xs="24" :sm="12" :md="8" :lg="6">
              <p class="lable-title">Country of Futher Education :</p>
              <a-select class="ant-select" show-search placeholder="select..." option-filter-prop="children"
                v-model="formSearch.country">
                <a-select-option v-for="(item, index) in optionCountry" :key="index" :value="item.value">
                  {{ item.text }}
                </a-select-option>
              </a-select>
            </a-col>
            <a-col :xs="24" :sm="12" :md="8" :lg="6">
              <p class="lable-title">Subscribe (Subscribe/Unsubscribe) :</p>
              <a-select class="ant-select" show-search placeholder="select..." option-filter-prop="children"
                v-model="formSearch.statusSub">
                <a-select-option v-for="(item, index) in ['Subscribe', 'Unsubscribe']" :key="index" :value="item">
                  {{ item }}
                </a-select-option>
              </a-select>
            </a-col>
          </a-row>

          <!-- zone D -->
          <a-row class="mt-20">
            <a-col style="text-align: center">
              <a-button class="mr-5" type="primary" @click="onSearchDataProfile">
                <a-icon type="search" theme="outlined" /> Search Data
              </a-button>

              <a-popconfirm placement="top" ok-text="Yes" cancel-text="No" @confirm="onclearFilter">
                <template slot="title">
                  <p>Are you sure to Clear a Filter ?</p>
                </template>
                <a-button type="danger"> Clear Filter </a-button>
              </a-popconfirm>
            </a-col>
          </a-row>
        </a-card>
      </div>
    </template>

    <!-- Top Pagination  -->
    <a-row class="mt-5 mb-10">
      <a-col :span="12" style="text-align: left">
        <a-tag color="blue">
          <p class="text-center mt-5 mb-0 font-bold">
            Total 
            <span class="text-danger"> {{ countObjData }}</span>
            record
          </p>
        </a-tag>
      </a-col>
      <a-col :span="12" style="text-align: right">
        <a-pagination :current="currentPage" :total="countObjData" @change="onChangePage" :defaultPageSize="perPage" />
      </a-col>
    </a-row>

    <a-table :columns="columns" :data-source="data" :pagination="false" :loading="loading" bordered size="small">
      <template slot="student_id" slot-scope="text, record">
        {{ record.student_id }}
      </template>

      <template slot="graduate_year" slot-scope="text, record">
        <p v-if="record.graduate_year">
          {{ record.graduate_year }}
        </p>
      </template>

      <template slot="full_name" slot-scope="text, record">
        <!-- <pre>{{ record.name_detail }}</pre> -->
        <p>
          <span v-if="record.name_detail.length > 0">
            {{ record.name_detail[record.name_detail.length - 1].eng_first_name }}
            {{ record.name_detail[record.name_detail.length - 1].eng_middle_name }}
            {{ record.name_detail[record.name_detail.length - 1].eng_last_name }}
          </span>
          &nbsp;&nbsp;

        </p>
      </template>

      <template slot="full_name_th" slot-scope="text, record">
        <!-- <pre>{{ record.name_detail }}</pre> -->
        <p>
          <span v-if="record.name_detail.length > 0">
            {{ record.name_detail[record.name_detail.length - 1].thai_first_name }}
            {{ record.name_detail[record.name_detail.length - 1].thai_middle_name }}
            {{ record.name_detail[record.name_detail.length - 1].thai_last_name }}
          </span>
          &nbsp;&nbsp;
        </p>
      </template>

      <template slot="graduate_status_detail" slot-scope="text, record">
        <a-tag v-if="!['', null].includes(record.graduate_status_detail)" :color="
          record.graduate_status_detail.name_eng ===
            'Complete the required course/Graduated'
            ? 'green'
            : record.graduate_status_detail.name_eng === 'Resigned'
              ? 'red'
              : ''
        ">
          {{ record.graduate_status_detail.name_eng }}
        </a-tag>
      </template>
      <template slot="updated_at" slot-scope="text, record, index">
        <div>
          {{
            moment(record.updated_at).format("YYYY-MM-DD")
            + ' ' +
            moment(record.updated_at).format("LTS")
          }}
        </div>
      </template>
      <template slot="action" slot-scope="text, record, index">
        <div>
          <a-button style="height: 30px" @click="onEditForm(record.id)">
            Open
          </a-button>
        </div>
      </template>
    </a-table>

    <!-- bottom pagination -->
    <a-row class="mt-10 mb-10">
      <a-col style="text-align: right">
        <a-pagination :current="currentPage" :total="countObjData" @change="onChangePage" :defaultPageSize="perPage" />
      </a-col>
    </a-row>

    <!-- modal components -->
    <component :is="currentModalComponent" :viewModal="isShowModal" :onShowModal="onShowModal"
      :onCloseModal="onCloseModal" :lengthDataTable="countObjData" :dataFilter="formSearch"></component>
    <!-- </a-modal> -->

  </a-card>
</template>

<script>
import typeImport from "./modal/AlumniImportType.vue";
import createProfile from "./modal/CreateProfile.vue";
import importAlumniProfile from "./modal/ImportAlumniProfile.vue";
import importAlumniName from "./modal/ImportAlumniName.vue";
import importAlumniContact from "./modal/ImportAlumniContact.vue";
import importAlumniEducation from "./modal/ImportAlumniEducation.vue";
import importAlumniWorkExperience from "./modal/ImportAlumniWorkExperience.vue";
import importAlumniMember from "./modal/ImportAlumniMember.vue";
import exportAlumniData from "./modal/ExportAlumniData.vue";

const formSearchRaw = {
  searchText: "",
  member: "",
  yearStart: "",
  yearEnd: "",
  grdStatus: "",
  nationality: "",
  program: "",
  jobStatus: "",
  major: "",
  country: "",
  statusSub: "",
};

export default {
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Array,
      default: () => [],
    },
    columns: {
      type: Array,
      default: () => [],
    },
    currentPage: {
      type: Number,
      default: () => 0,
    },
    countObjData: {
      type: Number,
      default: () => 0,
    },
    perPage: {
      type: Number,
      default: () => 0,
    },
    // option search
    optionNationality: {
      type: Array,
      default: () => [],
    },
    optionProgram: {
      type: Array,
      default: () => [],
    },
    optionJobselect: {
      type: Array,
      default: () => [],
    },
    optionMajor: {
      type: Array,
      default: () => [],
    },
    optionCountry: {
      type: Array,
      default: () => [],
    },
    optionYear: {
      type: Array,
      default: () => [],
    },
    loadBtnExport: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    // create new alumni
    toCreateData() {
      this.modalImport = false;
      this.modalCreate = true;
    },

    // create new alumni
    onChangePage(current) {
      this.$emit("changepage", {
        currentPage: current,
        offset: parseInt(current - 1) * parseInt(this.perPage),
      });
    },
    onclearFilter() {
      this.formSearch = JSON.parse(JSON.stringify(formSearchRaw))//Object.assign({}, formSearchRaw);
      this.$emit("search", {
        dataQuery: {},
      });
    },
    onSearchDataProfile() {
      this.$emit("search", {
        dataQuery: this.formSearch,
      });
    },
    onShowModal(modal) {
      this.isShowModal = true;
      this.currentModalComponent = modal
    },
    onCloseModal() {
      this.onSearchDataProfile();
      this.isShowModal = false;
    },
    onEditForm(id) {
      this.$router
        .push({
          path: "/alumni/formprofile",
          query: {
            id: `${id}`,
          },
        })
        .catch((err) => { });
    },
    handleMemberStatusChange(value) {
      this.formSearch.member = this.formSearch.member === value ? '' : value;
    }
  },
  data() {
    return {
      formSearch: JSON.parse(JSON.stringify(formSearchRaw)),//Object.assign({}, formSearchRaw),
      modalImport: false,
      modalCreate: false,
      isShowImportType: false,
      isShowModal: false,
      memberT: '',
      currentModalComponent: 'importType',
      formSearchT: {
        member: ''
      }
    };
  },
  components: {
    typeImport,
    createProfile,
    importAlumniProfile,
    importAlumniName,
    importAlumniContact,
    importAlumniEducation,
    importAlumniWorkExperience,
    importAlumniMember,
    exportAlumniData
  },
};
</script>

<style>
.ant-select {
  width: 80%;
}

.lable-title {
  margin-top: 5px;
  margin-bottom: 5px;
}

.ant-card-head-title span {
  margin-left: 0px;
}

.ant-card-filter {
  border: none;
}
</style>